module.exports = __webpack_public_path__ + "img/full7-min.9cd69086.png";